import { render, staticRenderFns } from "./qCardOverview.vue?vue&type=template&id=3252bbf1&scoped=true&"
import script from "./qCardOverview.vue?vue&type=script&lang=js&"
export * from "./qCardOverview.vue?vue&type=script&lang=js&"
import style0 from "./qCardOverview.vue?vue&type=style&index=0&id=3252bbf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3252bbf1",
  null
  
)

export default component.exports